import { callPost } from '../graphql';
import { BAGY_PAY_VINDI_GET_BALANCE } from '../graphql/query';

export const getBalance = async () => {
    const { data: axiosData } = await callPost(BAGY_PAY_VINDI_GET_BALANCE, {});
    const { data } = axiosData;
    return data.bagyPayVindiGetBalance;
};
